import * as Types from '../../gql.generated';

import { FixedRatesFragmentFragment } from './FixedRatesFragment.generated';
import { TransportFragmentFragment } from './transportFragment.generated';
import gql from 'graphql-tag';
import { TransportFragmentFragmentDoc } from './transportFragment.generated';
import { FixedRatesFragmentFragmentDoc } from './FixedRatesFragment.generated';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type CreateProvingGroundMutationVariables = {
  input?: Types.Maybe<Types.ProvingGroundInsertType>
};


export type CreateProvingGroundMutation = (
  { __typename?: 'Mutation' }
  & { createProvingGround: (
    { __typename?: 'ProvingGround' }
    & Pick<Types.ProvingGround, '_id' | 'title' | 'abbr' | 'countryCode' | 'specialNote' | 'inactive'>
  ) }
);

export type UpdateProvingGroundMutationVariables = {
  _id?: Types.Maybe<Types.Scalars['ID']>,
  update?: Types.Maybe<Types.ProvingGroundSetType>
};


export type UpdateProvingGroundMutation = (
  { __typename?: 'Mutation' }
  & { updateProvingGround: Array<(
    { __typename?: 'ProvingGround' }
    & Pick<Types.ProvingGround, '_id' | 'title' | 'abbr' | 'countryCode' | 'specialNote' | 'inactive'>
  )> }
);

export type DeleteProvingGroundMutationVariables = {
  _ids: Array<Types.Scalars['ID']>
};


export type DeleteProvingGroundMutation = (
  { __typename?: 'Mutation' }
  & { deleteProvingGround: Array<(
    { __typename?: 'ProvingGround' }
    & Pick<Types.ProvingGround, '_id' | '_deleted'>
  )> }
);

export type ReadProvingGroundsQueryVariables = {
  search?: Types.Maybe<Types.Scalars['String']>
};


export type ReadProvingGroundsQuery = (
  { __typename?: 'Query' }
  & { provingGrounds: Array<(
    { __typename?: 'ProvingGround' }
    & Pick<Types.ProvingGround, '_id' | '_deleted' | 'title' | 'abbr' | 'countryCode' | 'specialNote' | 'inactive' | 'drivingLessons' | 'hideFlight' | 'hideFerryConnection' | 'hideNordschleife' | 'hideHotels' | 'skipClearing' | 'racewayHours' | 'showNMF' | 'showSpecialUsage' | 'deleteEditor' | 'licensePlateMandatory' | 'participantsMandatory' | 'vehiclesMandatory' | 'accomodationsMandatory' | 'useUsageTimespansOnly' | 'vehicleTransportToDays' | 'vehicleTransportFromDays' | 'noteHeaderVehicles' | 'noteVehicles' | 'noteHeaderMaterials' | 'noteMaterials' | 'note1' | 'note2' | 'note3' | 'annotation' | 'block1' | 'block2' | 'block3' | 'block4' | 'block5' | 'block6' | 'block7' | 'block8' | 'block9' | 'block10' | 'block1Note' | 'block2Note' | 'block3Note' | 'block4Note' | 'block5Note' | 'block6Note' | 'block7Note' | 'block8Note' | 'block9Note' | 'block10Note' | 'block1Files' | 'block2Files' | 'block3Files' | 'block4Files' | 'block5Files' | 'block6Files' | 'block7Files' | 'block8Files' | 'block9Files' | 'block10Files'>
    & { outboundTransportSender: Types.Maybe<{ __typename?: 'SenderRecipient' }
      & TransportFragmentFragment
    >, outboundTransportRecipient: Types.Maybe<{ __typename?: 'SenderRecipient' }
      & TransportFragmentFragment
    >, returnTransportSender: Types.Maybe<{ __typename?: 'SenderRecipient' }
      & TransportFragmentFragment
    >, returnTransportRecipient: Types.Maybe<{ __typename?: 'SenderRecipient' }
      & TransportFragmentFragment
    >, clearing: Types.Maybe<Array<(
      { __typename?: 'User' }
      & Pick<Types.User, '_id' | 'type' | 'name' | 'firstName' | 'lastName' | 'email' | 'department' | 'upn'>
    )>>, editors: Types.Maybe<Array<(
      { __typename?: 'User' }
      & Pick<Types.User, '_id' | 'type' | 'name' | 'firstName' | 'lastName' | 'email' | 'department' | 'upn'>
    )>>, resourceManagers: Types.Maybe<Array<(
      { __typename?: 'User' }
      & Pick<Types.User, '_id' | 'type' | 'name' | 'firstName' | 'lastName' | 'email' | 'department' | 'upn'>
    )>>, authorizedEditors: Types.Maybe<Array<(
      { __typename?: 'User' }
      & Pick<Types.User, '_id' | 'type' | 'name' | 'firstName' | 'lastName' | 'email' | 'department' | 'upn'>
    )>>, fixedRates: Types.Maybe<{ __typename?: 'FixedRates' }
      & FixedRatesFragmentFragment
    > }
  )> }
);

export const CreateProvingGroundDocument = gql`
    mutation CreateProvingGround($input: ProvingGroundInsertType) {
  createProvingGround(input: $input) {
    _id
    title
    abbr
    countryCode
    specialNote
    inactive
  }
}
    `;
export type CreateProvingGroundMutationFn = ApolloReactCommon.MutationFunction<CreateProvingGroundMutation, CreateProvingGroundMutationVariables>;

    export function useCreateProvingGroundMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateProvingGroundMutation, CreateProvingGroundMutationVariables>) {
      return ApolloReactHooks.useMutation<CreateProvingGroundMutation, CreateProvingGroundMutationVariables>(CreateProvingGroundDocument, baseOptions);
    };
export type CreateProvingGroundMutationHookResult = ReturnType<typeof useCreateProvingGroundMutation>;
export type CreateProvingGroundMutationResult = ApolloReactCommon.MutationResult<CreateProvingGroundMutation>;
export type CreateProvingGroundMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateProvingGroundMutation, CreateProvingGroundMutationVariables>;
export const UpdateProvingGroundDocument = gql`
    mutation UpdateProvingGround($_id: ID, $update: ProvingGroundSetType) {
  updateProvingGround(filter: {_id: {EQ: $_id}}, update: {set: $update}) {
    _id
    title
    abbr
    countryCode
    specialNote
    inactive
  }
}
    `;
export type UpdateProvingGroundMutationFn = ApolloReactCommon.MutationFunction<UpdateProvingGroundMutation, UpdateProvingGroundMutationVariables>;

    export function useUpdateProvingGroundMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateProvingGroundMutation, UpdateProvingGroundMutationVariables>) {
      return ApolloReactHooks.useMutation<UpdateProvingGroundMutation, UpdateProvingGroundMutationVariables>(UpdateProvingGroundDocument, baseOptions);
    };
export type UpdateProvingGroundMutationHookResult = ReturnType<typeof useUpdateProvingGroundMutation>;
export type UpdateProvingGroundMutationResult = ApolloReactCommon.MutationResult<UpdateProvingGroundMutation>;
export type UpdateProvingGroundMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateProvingGroundMutation, UpdateProvingGroundMutationVariables>;
export const DeleteProvingGroundDocument = gql`
    mutation DeleteProvingGround($_ids: [ID!]!) {
  deleteProvingGround(filter: {_id: {IN: $_ids}}) {
    _id
    _deleted
  }
}
    `;
export type DeleteProvingGroundMutationFn = ApolloReactCommon.MutationFunction<DeleteProvingGroundMutation, DeleteProvingGroundMutationVariables>;

    export function useDeleteProvingGroundMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteProvingGroundMutation, DeleteProvingGroundMutationVariables>) {
      return ApolloReactHooks.useMutation<DeleteProvingGroundMutation, DeleteProvingGroundMutationVariables>(DeleteProvingGroundDocument, baseOptions);
    };
export type DeleteProvingGroundMutationHookResult = ReturnType<typeof useDeleteProvingGroundMutation>;
export type DeleteProvingGroundMutationResult = ApolloReactCommon.MutationResult<DeleteProvingGroundMutation>;
export type DeleteProvingGroundMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteProvingGroundMutation, DeleteProvingGroundMutationVariables>;
export const ReadProvingGroundsDocument = gql`
    query ReadProvingGrounds($search: String) {
  provingGrounds(filter: {OR: [{title: {REGEX: $search, OPTIONS: "i"}}, {abbr: {REGEX: $search, OPTIONS: "i"}}, {countryCode: {REGEX: $search, OPTIONS: "i"}}]}) {
    _id
    _deleted
    title
    abbr
    countryCode
    specialNote
    inactive
    drivingLessons
    hideFlight
    hideFerryConnection
    hideNordschleife
    hideHotels
    skipClearing
    racewayHours
    showNMF
    showSpecialUsage
    deleteEditor
    licensePlateMandatory
    participantsMandatory
    vehiclesMandatory
    accomodationsMandatory
    useUsageTimespansOnly
    vehicleTransportToDays
    vehicleTransportFromDays
    outboundTransportSender {
      ...TransportFragment
    }
    outboundTransportRecipient {
      ...TransportFragment
    }
    returnTransportSender {
      ...TransportFragment
    }
    returnTransportRecipient {
      ...TransportFragment
    }
    noteHeaderVehicles
    noteVehicles
    noteHeaderMaterials
    noteMaterials
    note1
    note2
    note3
    annotation
    clearing {
      _id
      type
      name
      firstName
      lastName
      email
      department
      upn
    }
    editors {
      _id
      type
      name
      firstName
      lastName
      email
      department
      upn
    }
    resourceManagers {
      _id
      type
      name
      firstName
      lastName
      email
      department
      upn
    }
    authorizedEditors {
      _id
      type
      name
      firstName
      lastName
      email
      department
      upn
    }
    block1
    block2
    block3
    block4
    block5
    block6
    block7
    block8
    block9
    block10
    block1Note
    block2Note
    block3Note
    block4Note
    block5Note
    block6Note
    block7Note
    block8Note
    block9Note
    block10Note
    block1Files
    block2Files
    block3Files
    block4Files
    block5Files
    block6Files
    block7Files
    block8Files
    block9Files
    block10Files
    fixedRates {
      ...FixedRatesFragment
    }
  }
}
    ${TransportFragmentFragmentDoc}
${FixedRatesFragmentFragmentDoc}`;

    export function useReadProvingGroundsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ReadProvingGroundsQuery, ReadProvingGroundsQueryVariables>) {
      return ApolloReactHooks.useQuery<ReadProvingGroundsQuery, ReadProvingGroundsQueryVariables>(ReadProvingGroundsDocument, baseOptions);
    };
      export function useReadProvingGroundsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ReadProvingGroundsQuery, ReadProvingGroundsQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<ReadProvingGroundsQuery, ReadProvingGroundsQueryVariables>(ReadProvingGroundsDocument, baseOptions);
      };
      
export type ReadProvingGroundsQueryHookResult = ReturnType<typeof useReadProvingGroundsQuery>;
export type ReadProvingGroundsQueryResult = ApolloReactCommon.QueryResult<ReadProvingGroundsQuery, ReadProvingGroundsQueryVariables>;